/**
 * Partially mask an email address for display. Enough is left for the owner to
 * recognise their own address ("is that the one I signed up with?") without
 * spelling it out for whoever else is looking at the screen.
 *   can@marsalasoft.com → ca*@ma*********.com
 */
export function maskEmail(email: string): string {
  const at = email.lastIndexOf("@");
  if (at <= 0 || at === email.length - 1) return email;
  const local = email.slice(0, at);
  const domain = email.slice(at + 1);
  // Keep the TLD readable — it carries no identity on its own.
  const dot = domain.lastIndexOf(".");
  const host = dot > 0 ? domain.slice(0, dot) : domain;
  const tld = dot > 0 ? domain.slice(dot) : "";
  return `${keepHead(local)}@${keepHead(host)}${tld}`;
}

/** First two characters (one for a very short part), the rest starred. */
function keepHead(part: string): string {
  const head = part.slice(0, part.length <= 2 ? 1 : 2);
  return head + "*".repeat(Math.max(part.length - head.length, 1));
}
